import { API, unwrapData } from '../axios-instance'
import { PageResult } from '../shared/types'
import {
  ExtendNominationParams,
  FinalizeWinnersParams,
  ListCandidatesParams,
  ListCandidatesResult,
  ListNominationsParams,
  ListNomineesParams,
  ListWinnersParams,
  NominateParams,
  Nomination,
  Nominee,
  Winner,
} from './types'

export const deleteNomination = async (nominationId: string) => {
  return await API.delete<boolean>(`/award/awardTypes/${nominationId}`)
}

export const nominate = async (awardTypeId: string, params: NominateParams) => {
  return await API.post<Nomination>(`/award/awardTypes/${awardTypeId}/nominations`, params).then(
    unwrapData,
  )
}

export const listCandidates = async (awardTypeId: string, params: ListCandidatesParams) => {
  return await API.get<ListCandidatesResult>(`/award/awardTypes/${awardTypeId}/candidates`, {
    params,
  }).then(unwrapData)
}

export const startNomination = async (awardTypeId: string) => {
  return await API.post<Nomination>(`/award/awardTypes/${awardTypeId}/start`).then(unwrapData)
}

export const endNomination = async (awardTypeId: string) => {
  return await API.post<Nomination>(`/award/awardTypes/${awardTypeId}/end`).then(unwrapData)
}

export const extendNomination = async (awardTypeId: string, params: ExtendNominationParams) => {
  return await API.post<Nomination>(`/award/awardTypes/${awardTypeId}/extend`, params).then(
    unwrapData,
  )
}

export const listNominees = async (awardTypeId: string, params: ListNomineesParams) => {
  return await API.get<PageResult<Nominee>>(`/award/awardTypes/${awardTypeId}/nominees`, {
    params,
  }).then(unwrapData)
}

export const listWinners = async (awardTypeId: string, params: ListWinnersParams) => {
  return await API.get<PageResult<Winner>>(`/award/awardTypes/${awardTypeId}/winners`, {
    params,
  }).then(unwrapData)
}

export const addWinner = async (awardTypeId: string, nomineeId: string) => {
  return await API.post<Nominee>(`/award/awardTypes/${awardTypeId}/winners`, {
    memberId: nomineeId,
  }).then(unwrapData)
}

export const removeWinner = async (awardTypeId: string, nomineeId: string) => {
  return await API.delete<boolean>(`/award/awardTypes/${awardTypeId}/winners/${nomineeId}`).then(
    unwrapData,
  )
}

export const finalizeWinners = async (awardTypeId: string, params?: FinalizeWinnersParams) => {
  return await API.post<Nomination>(`/award/awardTypes/${awardTypeId}/finalize`, params).then(
    unwrapData,
  )
}

export const listNominations = async (awardTypeId: string, params: ListNominationsParams) => {
  return await API.get<PageResult<Nomination>>(`/award/awardTypes/${awardTypeId}/nominations`, {
    params,
  }).then(unwrapData)
}

export const exportNominationsCsv = async (awardTypeId: string) => {
  return await API.post<BlobPart>(`/award/awardTypes/${awardTypeId}/nominations/export`).then(
    unwrapData,
  )
}
